import actionTypes from './action_types';

export function addNotification(notification) {
  return (dispatch) => {
    return dispatch({
      type: actionTypes.NOTIFICATION_ADDED,
      payload: { notification },
    });
  };
}

export function clearNotification() {
  return (dispatch) => {
    return dispatch({
      type: actionTypes.NOTIFICATION_SHOWN,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/notifications.js